export default "__VITE_ASSET__CqRV49tn__"